export const LISTE_MARCHE = {
  title: 'Liste des marchés',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des marchés',
  },
  actions: {
    add: 'Nouveau marché',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  tab: {
    code: 'Code',
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
    dateSignature: 'Date signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    reconductibleTacitement: 'Reconductible',
  },
  filtre: {
    code: 'Code',
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
  },
};

export const ADD_MARCHE = {
  title: {
    add: 'Création d\'un marché',
    edit: 'Modification du marché',
  },
  breadcrumb: {
    add: 'Création marché',
    edit: 'Modification marché',
    racine: 'Accueil',
    liste: 'Liste des marchés',
  },
  addFournisseur: {
    fournisseur: 'Fournisseur',
    pourcentage: 'Répartition',
    title: 'Ajouter un fournisseur',
    commercialName: 'Nom commercial',
    postalAddress: 'Adresse postale',
    compteComptable: 'Compte comptable',
    address: 'Adresse',
  },
  tabs: {
    informations: 'Marché',
    produits: 'Produits',
    fournisseurs: 'Fournisseurs',
  },
  validation: {
    sumCommissions: 'La répartition des commissions doit être de 100%',
  },
  information: {
    title: 'Informations générales',
    code: 'Code',
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
    dateSignature: 'Date signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    reconductibleTacitement: 'Reconductible',
  },
  produits: {
    tab: {
      reference: 'Référence',
      type: 'Type',
      label: 'Libellé',
      societe: 'Société',
      agence: 'Agence',
      regroupementProduit: 'Regr.',
      actif: 'Archivé',
    },
    filtre: {
      categorie: 'Liste des types de produits',
      actif: 'Actif',
      societe: 'Societé',
      agence: 'Agence',
      avecLiaisons: 'Avec produit(s) associé(s)',
    },
    newProductPresse: 'Ajouter produit presse',
    newProductAutre: 'Autre',
    newProductSalon: 'Salon',
    newProductSponsoring: 'Sponsoring / Evénementiel',
    regroupementProduit: 'Regroupement de produit: {name}',
  },
  notifications: {
    successCreation: 'Création du marché réalisée avec succès.',
    successChange: 'Modification du marché réalisée avec succès.',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  error: {
    champsObligatoire: 'Le champs {name} est obligatoire',
    fournisseurObligatoire: 'Vous devez ajouter un fournisseur pour enregistrer le marché',
    onlyOne: 'Une commission par fournisseur est autorisé',
    sumMustBeOneHundred: 'Le total des commissions doit faire 100%',
  },
};

export const DETAIL_MARCHE = {
  title: 'Détail marché: {libelle}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des marchés',
    detail: 'Détail marché: {libelle}',
  },
  tabs: {
    informations: 'Marché',
    produits: 'Produits',
    fournisseur: 'Fournisseurs',
    ventesMarche: 'Ventes support',
  },
  information: {
    title: 'Informations générales',
    code: 'Code',
    libelle: 'Libellé',
    fournisseur: 'Fournisseur',
    dateSignature: 'Date signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    reconductibleTacitement: 'Reconductible',
  },
  ventesMarche: {
    tabs: {
      planMedia: 'Plan média',
      commande: 'Commande',
      produit: 'Support',
      payeur: 'Payeur',
      annonceur: 'Annonceur',
      dateDevisCommande: 'Date signature',
      dateTransmissionAuClient: 'Date transmission au client',
      dateTransmissionAuClub: 'Date transmission au club',
      tauxReversement: 'Taux de reversement',
      totalLigneEch: 'Total Ech.',
      pourcentageTotal: 'Reversement',
    },
    filtre: {
      periodeAnalyse: 'Période d\'analyse',
      planMedia: 'Plan média',
      codeCmd: 'N° cmd',
      produits: 'Code(s) support',
      payeurs: 'Payeur(s)',
      annonceurs: 'Annonceur(s)',
      afficherDevis: 'Afficher lignes de devis',
    },
    popupInfoVentes: {
      title: 'Informations ventes',
      facture: 'Facture',
      factureeLe: 'facturée le',
      echeancierPrevuPourLe: 'Echéancier prévu pour le',
    },
  },
};
